import React, { useState, useEffect } from 'react';

// Simple in-memory payment state for demo purposes.
// In a real app this should be backed by a server or persistent storage.
let _isPaid = true;

export function isProjectPaid() {
  return _isPaid;
} 

export function markProjectPaid() {
  _isPaid = true;
}

export function markProjectUnpaid() {
  _isPaid = false;
}

/**
 * PaymentStatus component
 * Props:
 *  - projectId (optional) : identifier for the project (not used in this demo)
 */
export default function PaymentStatus({ projectId }) {
  const [paid, setPaid] = useState(isProjectPaid());

  useEffect(() => {
    setPaid(isProjectPaid());
  }, []);

  function handlePayClick() {
    // demo: marking paid locally
    markProjectPaid();
    setPaid(true);
  }

  function handleRevertClick() {
    markProjectUnpaid();
    setPaid(false);
  }

  return (
    <div style={{padding: 12, border: '1px solid #ddd', borderRadius: 6}}>
      <h3>Payment</h3>
      <p>Project ID: {projectId || '—'}</p>
      <p>
        Status: <strong style={{color: paid ? 'green' : 'red'}}>{paid ? 'Paid' : 'Unpaid'}</strong>
      </p>
      <div style={{display: 'flex', gap: 8}}>
        {!paid ? (
          <button onClick={handlePayClick}>Mark as paid</button>
        ) : (
          <button onClick={handleRevertClick}>Mark as unpaid</button>
        )}
      </div>
    </div>
  );
}
